var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9 9.99996H10.9C10.9 9.45296 11.3533 8.90009 12 8.90009C12.5936 8.90009 13.1 9.25152 13.1 9.99996C13.1 10.602 12.573 11.0544 12.047 11.506L12.0134 11.5348C11.5207 11.9574 11.0026 12.4017 11.0026 13.2344C11.0026 13.8714 11.0012 13.9838 11.0004 14H13V13.4486C13 12.9386 13.4137 12.5907 13.7708 12.2904L13.7708 12.2904L13.7708 12.2904L13.771 12.2902C13.8221 12.2473 13.8719 12.2054 13.9193 12.1641C14.4463 11.7043 15 10.9237 15 9.99996C15 8.36013 13.9323 6.99609 12.0154 6.99609C9.91481 6.99609 9 8.76518 9 9.99996ZM13.1004 16.0934C13.0968 15.4889 12.6057 15 12.0004 15C11.3951 15 10.904 15.4889 10.9004 16.0934L10.9004 16.0867V16.1L10.9004 16.0934C10.904 16.6978 11.3951 17.1867 12.0004 17.1867C12.6057 17.1867 13.0968 16.6978 13.1004 16.0934ZM13.1004 16.0934L13.1004 16.0867V16.1L13.1004 16.0934Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.c30b6d2844210c156da9e6f7c987d037.svg";
export { ForwardRef as ReactComponent };